import { Validators } from '@angular/forms';
import { REGEX } from './regex.util';

export const emailValidator = Validators.pattern(REGEX.EMAIL_REGEX);
